import ComplicationEdit from "./ComplicationEdit";
import ComplicationManagement from "./ComplicationManagement";
import ComplicationResolution from "./ComplicationResolution";

export { ComplicationEdit, ComplicationManagement, ComplicationResolution };
